import React from 'react';
import { Reveal } from './Reveal';
import { CTABanner } from './CTABanner';
import { useParallax } from '../hooks/useParallax';
import { useLanguage } from '../contexts/LanguageContext';
const SERVICE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/f5dbfca1-c79d-4844-83a8-b55a15144273.jpg';
const highlightImages = ['https://cdn.magicpatterns.com/patterns/generated-images/3a7c138a-54af-48c0-abb7-65ff9cd03feb.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/ff8f8d72-3bb6-417b-9f97-a029aece543e.jpg'];
export function ServiceCenter() {
  const {
    t
  } = useLanguage();
  const {
    ref,
    offset
  } = useParallax<HTMLDivElement>(0.3);
  return <section id="servicio" aria-labelledby="servicio-title" className="scroll-mt-24 border-t border-line bg-canvas" data-id="element-266" data-mp="4y7se77zmf0g">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-267" data-mp="iz22qveliq1r">
        {/* Taller certificado */}
        <div ref={ref} className="relative h-80 overflow-hidden bg-surface sm:h-[30rem] lg:h-full lg:min-h-[760px]" data-id="element-268" data-mp="dzyzngi6etwf">
          <img src={SERVICE_IMAGE} alt={t.service.imageAlt} loading="lazy" className="absolute inset-0 h-[150%] w-full object-cover" style={{
          transform: `translate3d(0, ${offset}px, 0)`
        }} data-id="element-269" data-mp="3m06ulrgie6rn" />
          <span className="pointer-events-none absolute left-6 top-6 h-5 w-5 border-l border-t border-white/35" aria-hidden="true" data-id="element-270" data-mp="3t928lrstqjz" />
          <span className="pointer-events-none absolute right-6 top-6 h-5 w-5 border-r border-t border-white/35" aria-hidden="true" data-id="element-271" data-mp="dqdo0khqfk09" />
          <span className="pointer-events-none absolute bottom-6 right-6 h-5 w-5 border-b border-r border-white/35" aria-hidden="true" data-id="element-272" data-mp="ijgjwz9zf5jm" />
          <span className="absolute bottom-6 left-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-white/70" data-id="element-273" data-mp="rjmwmixuw1hq">
            <span className="h-px w-6 bg-white/40" aria-hidden="true" data-id="element-274" data-mp="wesg7b3sd42n" />
            {t.service.caption}
          </span>
        </div>

        {/* Copy y CTA */}
        <div className="flex flex-col justify-center px-5 py-16 sm:px-6 sm:py-24 lg:border-l lg:border-line lg:px-20 lg:py-32" data-id="element-275" data-mp="2ojzfbf1twi52">
          <Reveal data-id="element-276" data-mp="32c5yla0a358q">
            <p className="text-[11px] uppercase tracking-[0.34em] text-mute" data-id="element-277" data-mp="2xjctgl0wduw4">{t.service.eyebrow}</p>
            <h2 id="servicio-title" className="mt-6 max-w-lg text-[32px] font-light leading-[1.08] tracking-[-0.03em] text-white lg:text-[52px]" data-id="element-278" data-mp="3c88wu4s0ejqe">
              {t.service.title}
            </h2>
          </Reveal>

          <ul className="mt-14 divide-y divide-line border-y border-line" data-id="element-279" data-mp="3l8f7zk08j7me">
            {t.service.highlights.map((item, i) => <li key={item.title} data-id="element-280" data-mp="3g81b8y433k3o" data-mpi={i}>
                <Reveal delay={i * 0.1} data-id="element-281" data-mp="1qu4jjcnjyfh5">
                  <div className="group flex items-start gap-6 py-10 lg:gap-10" data-id="element-282" data-mp="1qv65wda0qoe6">
                    <div className="w-20 shrink-0 overflow-hidden bg-surface lg:w-28" data-id="element-283" data-mp="1lx4kvmt18f02">
                      <img src={highlightImages[i]} alt="" loading="lazy" className="aspect-square w-full object-cover opacity-85 transition-[opacity,transform] duration-[900ms] ease-[var(--ease-lux)] group-hover:scale-[1.08] group-hover:opacity-100" data-id="element-284" data-mp="1etwnfsojyri" />
                    </div>
                    <div data-id="element-285" data-mp="3ernfpvknjuux">
                      <p className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-mute" data-id="element-286" data-mp="3erdo63jylfn4">
                        {`0${i + 1}`}
                        <span className="h-px w-6 bg-line transition-[width,background-color] duration-[800ms] ease-[var(--ease-lux)] group-hover:w-14 group-hover:bg-white/60" aria-hidden="true" data-id="element-287" data-mp="35sihkqd063ja" />
                      </p>
                      <h3 className="mt-3 text-xl font-normal tracking-tight text-white lg:text-2xl" data-id="element-288" data-mp="182r0uit0rwcq">
                        {item.title}
                      </h3>
                      <p className="mt-3 max-w-sm text-sm font-light leading-[1.8] text-mute lg:text-base" data-id="element-289" data-mp="j98mfa0t5ouc">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </Reveal>
              </li>)}
          </ul>

          <Reveal delay={0.1} data-id="element-290" data-mp="4geu2o0fte89">
            <a href="#contacto" className="btn-glint btn-glint-sheen btn-halo-red mt-10 inline-flex w-full items-center justify-center bg-guards px-10 py-4 text-[13px] font-medium tracking-wide text-white hover:bg-guards-bright sm:mt-12 sm:w-fit" data-id="element-291" data-mp="d8rbqcja56j">
              <span data-id="element-292" data-mp="3htgv3a3e35tq">{t.service.cta}</span>
            </a>
          </Reveal>
        </div>
      </div>

      {/* Banner interactivo — CTA iluminado en Guards Red */}
      <div className="mx-auto max-w-[1520px] px-5 pb-16 pt-14 sm:px-6 sm:pb-24 sm:pt-20 lg:px-14 lg:pb-32 lg:pt-28" data-id="element-293" data-mp="3ctcbvcb3jwzt">
        <CTABanner eyebrow={t.service.banner.eyebrow} title={t.service.banner.title} description={t.service.banner.description} ctaLabel={t.service.banner.cta} ctaHref="#contacto" tone="red" data-id="element-294" data-mp="38uwjsu05ryfj" />
      </div>
    </section>;
}